export default function getDeviceTypeFromHeaders() {
  let deviceType;

  try {
    const configObj = document.querySelector("script[data-bootstrap='configs']");
    deviceType = configObj ? JSON.parse(configObj.innerHTML).headerFooterContext.deviceType : 'DESKTOP';
  } catch (e) {
    deviceType = 'DESKTOP';
    console.error('Error in fetching deviceType - setting deviceType to DESKTOP: ', e);
  }

  return deviceType;
}
